import Icon from "../ui/Icon";
import { BRAND, THEMES, ENTITY_TYPES } from "../../config/constants";
import { inpStyle, lbl } from "../../utils/styles";

export default function BusinessCard({biz,idx,total,onChange,onRemove,theme}){
  const t=THEMES[theme];
  return(
    <div style={{background:t.bg,borderRadius:12,padding:16,border:`1px solid ${biz.isPrimary?BRAND.blue+"60":t.border}`,marginBottom:12,borderLeft:biz.isPrimary?`3px solid ${BRAND.blue}`:`3px solid transparent`}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div style={{fontSize:13,fontWeight:700,color:t.text}}>{biz.legalName||`Business ${idx+1}`}</div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <div style={{display:"flex",gap:14,alignItems:"center"}}>
            <label style={{display:"flex",alignItems:"center",gap:5,fontSize:11.5,color:t.textSub,cursor:"pointer"}}>
              <input type="checkbox" checked={!!biz.isPrimary} onChange={e=>onChange(idx,"isPrimary",e.target.checked)} style={{accentColor:BRAND.blue}}/>
              {biz.isPrimary?<span style={{color:BRAND.blue,fontWeight:700}}>Primary</span>:"Set Primary"}
            </label>
            <label style={{display:"flex",alignItems:"center",gap:5,fontSize:11.5,color:t.textSub,cursor:"pointer"}}>
              <input type="checkbox" checked={!!biz.isBookkeeping} onChange={e=>onChange(idx,"isBookkeeping",e.target.checked)} style={{accentColor:BRAND.green}}/>
              <span style={{color:biz.isBookkeeping?BRAND.green:t.textSub}}>📒 Bookkeeping</span>
            </label>
          </div>
          {total>0&&<button onClick={()=>onRemove(idx)} style={{background:"none",border:"none",cursor:"pointer",padding:3}}><Icon name="trash" size={14} color="#f87171"/></button>}
        </div>
      </div>
      <div style={{display:"flex",gap:10,marginBottom:10,flexWrap:"wrap"}}>
        <div style={{flex:1,minWidth:0}}>
        <label style={{...lbl,color:t.textSub}}>Legal Business Name</label>
        <input style={inpStyle(t)} value={biz.legalName||""} onChange={e=>onChange(idx,"legalName",e.target.value)} placeholder="ABC LLC"/>
      </div>
        <div style={{flex:"0 0 160px",minWidth:0}}>
        <label style={{...lbl,color:t.textSub}}>EIN</label>
        <input style={inpStyle(t)} value={biz.ein||""} onChange={e=>onChange(idx,"ein",e.target.value)} placeholder="XX-XXXXXXX"/>
      </div>
      </div>
      <div style={{display:"flex",gap:10,marginBottom:10}}>
        <div style={{flex:1}}>
          <label style={{...lbl,color:t.textSub}}>Entity Type</label>
          <select style={inpStyle(t)} value={biz.entityType||"LLC"} onChange={e=>onChange(idx,"entityType",e.target.value)}>{ENTITY_TYPES.map(x=><option key={x}>{x}</option>)}</select>
        </div>
        <div style={{flex:1,minWidth:0}}>
        <label style={{...lbl,color:t.textSub}}>Industry</label>
        <input style={inpStyle(t)} value={biz.industry||""} onChange={e=>onChange(idx,"industry",e.target.value)} placeholder="e.g. Consulting"/>
      </div>
      </div>
      <div style={{marginBottom:10}}>
        <label style={{...lbl,color:t.textSub}}>Business Address</label>
        <input style={inpStyle(t)} value={biz.address||""} onChange={e=>onChange(idx,"address",e.target.value)} placeholder="Street address"/>
      </div>
      <div style={{display:"flex",gap:10,marginBottom:10}}>
        <div style={{flex:1,minWidth:0}}>
        <label style={{...lbl,color:t.textSub}}>City</label>
        <input style={inpStyle(t)} value={biz.city||""} onChange={e=>onChange(idx,"city",e.target.value)} placeholder="San Diego"/>
      </div>
        <div style={{flex:"0 0 60px",minWidth:0}}>
        <label style={{...lbl,color:t.textSub}}>State</label>
        <input style={inpStyle(t)} value={biz.state||""} onChange={e=>onChange(idx,"state",e.target.value)} placeholder="CA"/>
      </div>
        <div style={{flex:"0 0 90px",minWidth:0}}>
        <label style={{...lbl,color:t.textSub}}>ZIP</label>
        <input style={inpStyle(t)} value={biz.zip||""} onChange={e=>onChange(idx,"zip",e.target.value)} placeholder="92101"/>
      </div>
        <div style={{flex:"0 0 110px",minWidth:0}}>
        <label style={{...lbl,color:t.textSub}}>Year Founded</label>
        <input style={inpStyle(t)} value={biz.yearFounded||""} onChange={e=>onChange(idx,"yearFounded",e.target.value)} placeholder="2018"/>
      </div>
      </div>
    </div>
  );
}

// Client Modal
